<template>
    <div>
        <el-dialog v-dialogDrag title="箱型箱量" :close-on-click-modal="false" :show-close="false"
            :visible.sync="dialogCartonVisible" width="60%">
            <div>
                <el-button @click="addRow">添加行</el-button>
                <!-- <el-button @click="saveAll" type="primary" style="margin-left: 10px">保存全部</el-button> -->
                <el-button @click="allSaveList" type="primary" style="margin-left: 10px">保存全部</el-button>
                <el-table :data="tableData" :empty-text="'没有数据'" size="mini" style="width: 100%" max-height="400px" >
                    <el-table-column prop="currency" label="集装箱号" >
                        <template slot-scope="scope">
                            <el-input size="mini" clearable v-model="scope.row.containerId" placeholder="请输入集装箱号"
                                v-if="scope.row.editing" width="100%"></el-input>
                            <span v-show="!scope.row.editing">{{ scope.row.containerId }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="account" label="箱型" >
                        <template slot-scope="scope">
                            <el-select size="mini" filterable clearable v-model="scope.row.containerType" placeholder="请选择箱型"
                                v-show="scope.row.editing">
                                <el-option v-for="item in classOption" :key="item.id" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-show="!scope.row.editing">{{ scope.row.containerType }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deliveryDate" label="到场日期" >
                        <template slot-scope="scope">
                            <el-date-picker size="mini" v-show="scope.row.editing" v-model="scope.row.deliveryDate" type="date"
                            value-format="yyyy-MM-dd"  placeholder="选择到场日期"  style="width:100%"></el-date-picker>
                            <span v-show="!scope.row.editing">{{ scope.row.deliveryDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="awayDate" label="离场日期" >
                        <template slot-scope="scope">
                            <el-date-picker size="mini" v-show="scope.row.editing" v-model="scope.row.awayDate" type="date"
                            value-format="yyyy-MM-dd"  placeholder="选择离场日期"  style="width:100%"></el-date-picker>
                            <span v-show="!scope.row.editing">{{ scope.row.awayDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="truckNo" label="车号" >
                        <!-- 输入车号 -->
                        <template slot-scope="scope">
                            <el-input size="mini" clearable v-model="scope.row.truckNo" placeholder="请输入车号" v-if="scope.row.editing"></el-input>
                            <span v-show="!scope.row.editing">{{ scope.row.truckNo }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="truckCompany" label="运输公司">
                        <!-- 字典查运输公司 -->
                        <template slot-scope="scope">
                            <el-select size="mini" filterable clearable v-model="scope.row.truckCompany" placeholder="请选择运输公司"
                                v-show="scope.row.editing">
                                <el-option v-for="item in truckCompanyList" :key="item.id" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-show="!scope.row.editing">{{ scope.row.truckCompany }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button v-if="!scope.row.editing" @click="startEditing(scope.row)" type="text"
                                size="small">
                                编辑
                            </el-button>
                            <el-button v-else @click="save(scope.row)" type="text" size="small">
                                保存
                            </el-button>
                            <el-button v-if="!scope.row.editing" @click="deleteRow(scope.row)" type="text" size="small"
                                style="margin-left: 10px">删除</el-button>
                            <el-button v-if="scope.row.id"  @click="fileUpload(scope.row)" type="text" size="small">
                                附件列表
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="beforeclose">取 消</el-button>
                <el-button type="primary" @click="allSaveList">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 上传附件列表 -->
        <el-dialog title="附件列表" :visible.sync="fileUploadCode" width="60%" :before-close="fileUploadClose">
            <div class="upload_box">
                <div class="upload_text">已上传附件列表</div>
                <div class="upload-list" >
                    <div v-for="item in fileuploadList" :key="item.id">
                        <el-link type="primary" class="list-margin" @click="downloadFile(item)">{{ item.annexName }}</el-link>
                    </div>
                </div>
            </div>
            <el-upload class="upload-demo" :action="saveOneAttachmentURL"  :on-remove="handleRemove" :on-change="handleChange"
                    multiple :file-list="fileList" :auto-upload="false">
                <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="fileUploadClose">取 消</el-button>
                <el-button type="primary" @click="sureUpload">上 传</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import draggable from '@/mixins/draggable.js'
import req from '@/utils/index.js'
import url from '@/config/url1.js'
import url1 from '@/config/url2.js'
export default {
    // directives: {
    //     draggable,
    // },

    name: 'sonQuantity',
    props: ['busId','callMixinMethod',], 
    data() {
        return {
            dialogCartonVisible: false,
            classOption: [],//箱型
            tableData: [],
            // busId: '',//单据编号id
            truckCompanyList:[], // 运输公司列表
            fileUploadCode:false, // 附件上传弹窗
            fileList:[], // 附件列表
            fileuploadList:[], // 附件列表已经上传
            fileId:'', // 上传文件所需id
            saveOneAttachmentURL:url1.saveOneAttachment, // 上传文件url
        }
    },
    created() {
    },
    mounted() {
        this.getClassOption();
        this.amendRow();
        this.getTruckCompanyList();

    },
    methods: {
        beforeclose() {
            this.dialogCartonVisible = false;
            // this.tableData = [];
            this.amendRow();
            this.$parent.smallTable();
            this.$nextTick(() => {
                this.$parent.smallTable();
                this.$parent.callMixinFromParent();
            })

        },
        // 获取装箱信息
        amendRow() {
            if(this.busId !== ''){
                let URL = `${url.getContainerList}/${this.busId}`;
                req.get(URL).then(res => {
                    if (res.data.code === 200) {
                        this.tableData = res.data.data;
                        this.tableData.forEach(row => {
                            this.$set(row, 'editing', false);
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        })
                    }
                })
            }
        },
        // 获取运输公司列表
        getTruckCompanyList(){
            let value = '运输公司';
            let URL = `${url.getDicList}/?value=${value}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.truckCompanyList = res.data.data.data;
                }
            })
        },
        // 获取箱型数据
        getClassOption() {
            let value = '箱型';
            let URL = `${url.getDicList}/?value=${value}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.classOption = res.data.data.data;
                }
            })
        },
        addRow() {
            const newRow = {
                containerId: '',
                containerType: '',
                editing: true,
                busId: this.busId
            };
            this.tableData.push(newRow);
        },
        deleteRow(row) {
            // 删除行的逻辑
            const index = this.tableData.indexOf(row);
            if (index !== -1) {
                this.tableData.splice(index, 1);
                if (row.id) {
                    let URL = `${url.deleteContainer}/${row.id}`;
                    req.delete(URL).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功'
                            })
                            this.amendRow();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }
                    })
                }

            }
        },
        startEditing(row) {
            this.$set(row, 'editing', true);
        },
        // 确定保存
        allSaveList() {
            let hasEmptyValue = false;
            this.tableData.forEach(row => {
                if (!row.containerId || !row.containerType) {
                    hasEmptyValue = true;
                    return false; // 提前退出循环
                }
            });
            if (hasEmptyValue) {
                this.$message.warning('请填写完整集装箱号和箱型');
            } else {
                // let flag = false;
                // this.tableData.forEach(row => {
                //     if (row.editing == true) {
                //         flag = true;
                //     }
                // })
                // if (flag) {
                //     this.$message({
                //         type: 'warning',
                //         message: '请先保存全部！'
                //     })
                // } else {
                    let URL = `${url.updateContainerList}`;
                     req.post(URL, this.tableData).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '更改成功'
                            })
                            this.amendRow();
                            this.callMixinMethod();//刷新箱型量信息
                            // this.beforeclose()
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }
                    })
                // }
            }
        },
        save(row) {
            this.$set(row, 'editing', false);
        },
        // saveAll() {
        //     this.tableData.forEach(row => {
        //         // row.editing = false;
        //         this.$set(row, 'editing', false);
        //     });
        // },
        // 文件上传打开弹窗
        fileUpload(data){
            this.fileId = data.id
            // 打开弹窗
            this.fileUploadCode = true
            this.fileList = []
            // 获取文件列表
            this.uploadFiles(this.fileId)
        },
        // 查询上传完文件
        uploadFiles(id){ 
            let URL = `${url1.getFileListByBusinessId}/${id}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.fileuploadList = res.data.data
                }
            })
        },
        // 关闭文件弹窗
        fileUploadClose(){
            this.fileUploadCode = false
            this.fileList = []
        },
        // 上传
        async sureUpload(){
            if(this.fileList.length){
                 try {
                    // 创建Promise数组
                    const promises = this.fileList.map(item => {
                        const formData = new FormData();
                        formData.append('file', item.raw);
                        formData.append('businessId', this.fileId);
                        let fileUrl = `${url1.saveOneAttachment}`
                        formData.append('annexType', '其他')
                         return this.saveOneAttachment(fileUrl, formData);
                    });
                    // 等待所有上传完成
                    await Promise.all(promises);
                    // 完成后操作
                    this.fileList = [];
                    this.uploadFiles(this.fileId)
                } catch (error) {
                    this.$message.error('上传失败: ' + error.message);
                }
            }
        },
        //   调用上传文件接口
        saveOneAttachment(fileUrl,formData){
            return req.post(fileUrl,formData).then(res => {
                if (res.data.code === 200) {
                    return res.data
                }else{
                    throw new Error(res.data.message || '上传失败');
                }
            })
        },
        // 文件预览
        downloadFile(data){
            const params = {
                path: '/preview',
                query: {
                    annexUrl: data.annexUrl,
                    annexName: data.annexName,
                    id: data.id
                }
            }
            var childWindow = window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
            var loop = setInterval(() => {
                if (childWindow.closed) {  // 检测子窗口是否关闭
                    clearInterval(loop); // 停止定时器
                    // 子窗口关闭后父页面刷新
                    this.uploadFiles(this.fileId)
                }
            }, 100);
        },
                // 文件上传时勾子
        handleChange(file, fileList){
            this.fileList = fileList;
        },
        // 移除文件勾子
        handleRemove(file, fileList){
            this.fileList = fileList;
        },
    },

}
</script>

<style lang="css" scoped>
.upload_box{
    width: 100%;
    display: flex;
}
.upload_text{
    text-align: right;
    width: 100px;
    margin-right: 10px;
    margin-bottom: 10px;
}
.upload-list{
    flex:1;
    display: flex;
    flex-wrap: wrap;
}
.list-margin{
    margin: 0px 5px;
}
</style>